import { JSONTag, Tag } from 'models/tag';
import TagsManagerBase from './base';

export default class PostsFilteringTagsManager extends TagsManagerBase {
    constructor(private discussionId: string, private memberStatus: number) {
        super();
    }

    addTag(jsonTag: JSONTag): Promise<void> {
        throw new Error('Unsupported operation');
    }

    removeTag(tag: Tag): Promise<void> {
        throw new Error('Unsupported operation');
    }

    protected async load() {
        switch (this.memberStatus) {
            case enums.MembershipStatusTypes.Moderator.value: return this.ctx.tagsService.queries.moderatorPostsFilteringTags(this.discussionId).toArray();
            case enums.MembershipStatusTypes.Observer.value: return this.ctx.tagsService.queries.observersPostsFilteringTags(this.discussionId).toArray();
            default: return [];
        }
    }
}